/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable radix */
/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getClientData } from '../../services/ClienteDados/getClientData'
import {
  cancelarBaixa,
  fetchDismiss,
  fetchDismissLote,
  fetchProductDetails,
  getPredictionsHistory,
  getPredictionsHistoryBaixa,
  getPredictionsPdf,
  getPredictionsSoldOff,
} from '../../services/PredictionsService/getPredictions'
import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import { getPedido } from '../../services/CriaPedido/getCriaPedido'
import { useSales } from '../Sales/useSales'

export const usePredictionDetails = () => {
  const { produto } = useSales()

  const data = localStorage.getItem('dataInicio')
  const dataSelecionadaPredicao = data ? JSON.parse(data) : null
  // Guard igual ao que Predictions.tsx ja fazia: entrar DIRETO em /predicao/:id ou /cliente/:id
  // (link da aba "Clientes por potencial", que abre em aba nova, mas tambem F5 ou favorito) com o
  // localStorage sem `dataInicio` quebrava a tela em branco - `null.split` e o projeto nao tem
  // ErrorBoundary. Sem data gravada, cai em hoje.
  const dataFormatada = dataSelecionadaPredicao
    ? dataSelecionadaPredicao.split('/')
    : []
  const dataValida = dataSelecionadaPredicao
    ? `${dataFormatada[1]}/${dataFormatada[0]}/${dataFormatada[2]}`
    : ''
  const formatData = dataValida ? dayjs(dataValida) : dayjs()
  const dataProximaCompra = formatData.format('DD/MM/YYYY')
  const [calendarInicio, setCalendarInicio] = useState(dataProximaCompra)
  const [predictionHistory, setpredictionHistory] = useState<GetHistoryType>(
    {} as GetHistoryType
  )
  const [predictionSoldOff, setPredictionSoldOff] = useState<GetSoldOffType>(
    {} as GetSoldOffType
  )
  const [predictionHistoryBaixa, setPredictionHistoryBaixa] =
    useState<GetSoldOffType>({} as GetSoldOffType)
  const [productDetails, setProductDetails] =
    useState<GetProductDetailPredictionType>(
      {} as GetProductDetailPredictionType
    )
  const [clientData, setClientData] = useState<GetClientData>()

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingHistory, setIsLoadingHistory] = useState(true)
  const [isLoadingHistoryBaixa, setIsLoadingHistoryBaixa] = useState(true)
  const [isLoadingSoldOff, setIsLoadingSoldOff] = useState(true)

  const [baixasSelecionadas, setBaixasSelecionadas] = useState<number[]>([])

  const [isProductDetails, setIsProductDetails] = useState(false)
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)
  const [isHistoricoBaixa, setIsHistoricoBaixa] = useState(false)
  const [currentPageHistory, setCurrentPageHistory] = useState(1)
  const [currentPageSoldOff, setCurrentPageSoldOff] = useState(1)
  const [currentPagesHistoryBaixa, setCurrentHistoryBaixa] = useState(1)
  const [isCriarPedido, setIsCriarPedido] = useState(false)

  const { id } = useParams()
  const [dias, setDias] = useState('30')
  const [produtos, setProdutos] = useState<GetPedido>({} as GetPedido)
  const [valueProductId, setValueProductId] = useState<number[]>([])
  const [valueProduct, setValueProduct] = useState<string[]>([])

  const arrayProdutos = Array.isArray(produto)
  const valueProductString = valueProduct.map(idProduto => {
    const productName = produto.find(name => name.nome === idProduto)
    return productName ? productName.id : undefined
  })
  const productArray = valueProductString.filter(
    value => value !== undefined
  ) as number[]

  const getHistory = async () => {
    setIsLoadingHistory(true)
    const result = await getPredictionsHistory(id!, currentPageHistory)
    setIsLoadingHistory(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setpredictionHistory(result)
    }
  }

  const getSoldOff = async () => {
    setIsLoadingSoldOff(true)
    setBaixasSelecionadas([])
    const result = await getPredictionsSoldOff(
      id!,
      calendarInicio,
      currentPageSoldOff
    )
    setIsLoadingSoldOff(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setPredictionSoldOff(result)
    }
  }

  const getHistoryBaixa = async () => {
    setIsLoadingHistoryBaixa(true)
    const result = await getPredictionsHistoryBaixa(
      id!,
      currentPagesHistoryBaixa
    )
    setIsLoadingHistoryBaixa(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setPredictionHistoryBaixa(result)
    }
  }

  const getBuscaProdutosPedido = async () => {
    setIsLoading(true)

    const result = await getPedido(
      dataProximaCompra,
      parseInt(dias),
      parseInt(id!)
    )
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setProdutos(result)
    }
  }

  const handleClientData = async () => {
    setIsLoading(true)
    const result = await getClientData(id!)
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setClientData(result)
    }
  }

  const handleIsProductDetails = () => {
    setIsProductDetails(!isProductDetails)
  }

  const handleIsHistoricoBaixa = () => {
    setIsHistoricoBaixa(!isHistoricoBaixa)
    getHistoryBaixa()
    getSoldOff()
  }

  const handleIsCriarPedido = () => {
    setIsCriarPedido(!isCriarPedido)
    localStorage.setItem('idCliente', JSON.stringify(id!))
  }

  const handleFiltroProduto = (event: string[]) => {
    setValueProduct(event)
  }

  const handleProdutoFiltrado = (event: number[]) => {
    setValueProductId(event)
  }

  const handleAddProduct = () => {
    setProdutos(prevProdutos => {
      const novosProdutos = valueProductId
        .map((id, index) => ({
          codigoIntegracao: 0,
          id, // aqui mantemos o nome do campo como 'id' para bater com o tipo GetPedido
          nome: valueProduct[index],
          quantidade: 0,
        }))
        .filter(
          novoProduto => !prevProdutos.some(item => item.id === novoProduto.id)
        )

      return [...prevProdutos, ...novosProdutos]
    })
  }

  useEffect(() => {
    handleProdutoFiltrado(productArray)
  }, [valueProduct])

  const cancelaUmaBaixa = async (idProduto: number, proximaCompra: string) => {
    const predicaoBaixaRequestDTO = {
      acertou: true,
      dataProximaCompra: proximaCompra,
      produtoId: idProduto,
    }

    const result = await cancelarBaixa(id, predicaoBaixaRequestDTO)

    if ('info' in result) {
      toast.success(result.info)
      getHistoryBaixa()
      return
    }
    toast.error(result.message)
  }

  function deletarItem(idProduto: number) {
    setProdutos(produtos.filter(item => item.id !== idProduto))
  }

  const consultar = async (produtoEsgotandoPredicao: number) => {
    setIsLoading(true)
    const result = await fetchProductDetails(produtoEsgotandoPredicao, id!)

    setIsLoading(false)

    if ('message' in result) {
      toast.error(result.message)
    } else {
      setProductDetails(result)
      setIsProductDetails(!isProductDetails)
    }
  }

  // Gera e baixa o PDF de predicao do cliente (mesmo escopo/data do painel "Produtos esgotando").
  const handleGerarPdf = async () => {
    setIsGeneratingPdf(true)
    const result = await getPredictionsPdf(id!, calendarInicio)
    setIsGeneratingPdf(false)

    if (result instanceof Blob) {
      const nomeCliente = clientData?.nome?.trim() || 'cliente'
      const nomeArquivo = `predicao-${nomeCliente.replace(
        /[\\/:*?"<>|]+/g,
        '_'
      )}.pdf`
      saveAs(result, nomeArquivo)
      return
    }
    toast.error(result.message)
  }

  const dismiss = async (idProduto: number, proximaCompra: string) => {
    const predicaoBaixaRequestDTO = {
      acertou: true,
      dataProximaCompra: proximaCompra,
      produtoId: idProduto,
    }

    const result = await fetchDismiss(id, predicaoBaixaRequestDTO)

    if ('info' in result) {
      toast.success(result.info)
      getSoldOff()
      return
    }
    toast.error(result.message)
  }

  const toggleBaixaSelecionada = (idProduto: number) => {
    setBaixasSelecionadas(prev =>
      prev.includes(idProduto)
        ? prev.filter(item => item !== idProduto)
        : [...prev, idProduto]
    )
  }

  const conteudoSoldOff = Array.isArray(predictionSoldOff.content)
    ? predictionSoldOff.content
    : []

  const todasBaixasSelecionadas =
    conteudoSoldOff.length > 0 &&
    baixasSelecionadas.length === conteudoSoldOff.length

  const toggleTodasBaixasSelecionadas = () => {
    setBaixasSelecionadas(
      todasBaixasSelecionadas ? [] : conteudoSoldOff.map(item => item.id)
    )
  }

  const dismissLote = async () => {
    if (baixasSelecionadas.length === 0) {
      toast.warn('Selecione ao menos um produto para dar baixa.')
      return
    }

    const baixas = conteudoSoldOff
      .filter(item => baixasSelecionadas.includes(item.id))
      .map(item => ({
        acertou: true,
        dataProximaCompra: item.proximaCompra,
        produtoId: item.id,
      }))

    const result = await fetchDismissLote(id, baixas)

    if ('info' in result) {
      toast.success(result.info)
      getSoldOff()
      return
    }
    toast.error(result.message)
  }

  useEffect(() => {
    getHistory()
  }, [currentPageHistory])

  useEffect(() => {
    getSoldOff()
  }, [currentPageSoldOff, calendarInicio])

  useEffect(() => {
    getHistoryBaixa()
  }, [currentPagesHistoryBaixa])

  useEffect(() => {
    getBuscaProdutosPedido()
    handleClientData()
  }, [isCriarPedido])
  useEffect(() => {}, [isCriarPedido])

  return {
    predictionHistory,
    predictionSoldOff,
    predictionHistoryBaixa,
    clientData,
    isLoading,
    isLoadingHistory,
    isLoadingHistoryBaixa,
    isLoadingSoldOff,
    dismiss,
    cancelaUmaBaixa,
    baixasSelecionadas,
    toggleBaixaSelecionada,
    todasBaixasSelecionadas,
    toggleTodasBaixasSelecionadas,
    dismissLote,

    currentPagesHistoryBaixa,
    currentPageHistory,
    setCurrentPageHistory,
    currentPageSoldOff,
    setCurrentPageSoldOff,
    setCurrentHistoryBaixa,

    setCalendarInicio,

    handleIsProductDetails,
    isProductDetails,
    productDetails,

    handleGerarPdf,
    isGeneratingPdf,

    handleIsHistoricoBaixa,
    isHistoricoBaixa,

    consultar,

    handleIsCriarPedido,
    isCriarPedido,
    getBuscaProdutosPedido,
    setDias,
    dias,
    produtos,
    deletarItem,
    handleFiltroProduto,
    handleAddProduct,
    handleProdutoFiltrado,
    arrayProdutos,

    produto,
    valueProduct,
    setValueProduct,
    valueProductId,
    setValueProductId,
    productArray,
  }
}
